import React from 'react';
import "./ShopfloorFooter.scss";
import logo from './../../common/assets/img/AMIG-Logo.png';
import { Box, Link, IconButton } from '@mui/material';
import appSettings from '../../appSettings';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ShopfloorFooter = () => {
  const history = useHistory();
  const customLinks = useSelector(state=> state.customLinks);
  const LEGALLINKFOOTER = 'LegalLinkFooter';
  const LEGALTEXTFOOTER = 'LegalTextFooter';

  const socialLinks = [
    { name: 'Facebook', url: appSettings.AMIG_FB, icon: 'fb-icon' },
    { name: 'LinkedIn', url: appSettings.AMIG_LINKEDIN, icon: 'linkedin-icon' },
    { name: 'Youtube', url: appSettings.AMIG_YOUTUBE, icon: 'youtube-icon' }
  ];

  const handleLegalLinkClick = () => {
    window.UC_UI.showSecondLayer();
  };

  function getLinks(links, linkCategory){
    const filteredLinks = links.filter(function(link) {
      return link.category === linkCategory;
    });

    return filteredLinks.sort((link1, link2) => {return link1.priority - link2.priority});
  };

  const footerLegalLinks = getLinks(customLinks, LEGALLINKFOOTER);
  const footerLegalParas = getLinks(customLinks, LEGALTEXTFOOTER);

  return (

    <Box className="shopfloor-footer-bg">
      <Box className="footer shopfloor-footer-bg">
        <Box> <Box className="footer-logo">
          <Link aria-label="American Modern Logo" onClick={() => {
            if (history.location.pathname !== '/') {
              window.location.replace('/');
            }
          }}>
            <img className="footer-logo-img" src={logo} alt="American Modern Logo" />
          </Link>
        </Box>
          <Box className="social-icons">
            {
              socialLinks.map((elem, index) => (
                <IconButton key={'social-icon-'+index} className='social-icon' aria-label={elem.name} onClick={() => {
                  window.open(elem.url, '_blank');
                }}>
                  <img
                    src={require('../../common/assets/img/' + elem.icon + '.png')}
                    alt='social icon'
                  />
                </IconButton>
              ))
            }
          </Box>
        </Box>
        <Box className="footer-content shopfloor-footer-content">
          {footerLegalParas?.length > 0 && <Box className="footer-text-content shopfloor-footer-content ">
            {footerLegalParas.map((elem, index) => (
              <Box key={'legal-paragraph-'+index}>{elem?.display}</Box>
            ))}
          </Box>}
          <Box className="footer-legal-links">
            <Box className="legal-links">
            {footerLegalLinks.map((elem, index) => (
              <React.Fragment key={index}>
                <Link href={elem.url} aria-label={elem.display} target='_blank' className='shopfloor-legal-link' underline='hover'>
                  {elem.display}
                </Link>
                <Box className='shopfloor-vertical-divider'>|</Box>
              </React.Fragment>
            ))}
            <Link onClick={handleLegalLinkClick} aria-label='Cookie Settings' className='shopfloor-legal-link' underline='hover'>Cookie settings</Link>
            </Box>
            <Box className='copyright shopfloor-footer-link-color'>©{new Date().getFullYear()}. American Modern Insurance Group, Inc. <Box className='rights-reserved shopfloor-footer-link-color'>All rights reserved.</Box></Box>
          </Box>
        </Box>
      </Box>
    </Box>

  )
}

export default ShopfloorFooter;
